import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import {
  getExtraCommercialQuoteTypeName,
  getQuotationTypeName,
} from '../../constants';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
  CompletedFieldGrid,
  CompletedField,
} from '../../../screens/CompletedQuotes/CompletedV2.styles';

function CompletedQuoteScreenInfoCommercial({ rc_quotation, risk_quotations }) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const renderRCQuotationContent = () => {
    if (rc_quotation.company_id === 16) {
      return (
        <CompletedFieldGrid>
          <CompletedField>
            <dt>Compagnia</dt>
            <dd>{rc_quotation.company.name}</dd>
          </CompletedField>
          <CompletedField>
            <dt>Stato</dt>
            <dd>
              {rc_quotation.status === 7 && 'Polizza Emmesa'}
            </dd>
          </CompletedField>
          <CompletedField>
            <dt>Data Decorrenza</dt>
            <dd>
              {moment(rc_quotation.insurance_request.policy_effective_date)
                .toDate()
                .toLocaleDateString('it-IT')}
            </dd>
          </CompletedField>
          <CompletedField>
            <dt>Polizza Pagata</dt>
            <dd>SI</dd>
          </CompletedField>
          {/* Totale (temporarily hidden)
<CompletedField className="full total">
            <dt>Totale</dt>
            <dd>
              {rc_quotation.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              &euro;
            </dd>
          </CompletedField>
*/}
          <CompletedField>
            <dt>Provvigioni</dt>
            <dd>
              {rc_quotation.commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              &euro;
            </dd>
          </CompletedField>
        </CompletedFieldGrid>
      );
    }

    return (
      <CompletedFieldGrid>
        <CompletedField>
          <dt>Compagnia</dt>
          <dd>{rc_quotation.company.name}</dd>
        </CompletedField>
        <CompletedField>
          <dt>Stato</dt>
          <dd>
            {rc_quotation.status === 7 && 'Polizza Emmesa'}
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Data Decorrenza</dt>
          <dd>
            {moment(rc_quotation.insurance_request.policy_effective_date)
              .toDate()
              .toLocaleDateString('it-IT')}
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Freq. Pagamento</dt>
          <dd>
            {rc_quotation.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Pagato</dt>
          <dd>
            {rc_quotation.amount_paid === null
              ? '0'
              : rc_quotation.amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            {' '}
            &euro;
          </dd>
        </CompletedField>
        {/* Da Pagare (temporarily hidden)
        <CompletedField>
          <dt>Da Pagare</dt>
          <dd>
            {rc_quotation.amount_paid === rc_quotation.amount
              ? '0'
              : (
                Math.ceil(rc_quotation.amount * 100) / 100
                - rc_quotation.amount_paid
              ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            {' '}
            &euro;
          </dd>
        </CompletedField>
        */}
        <CompletedField>
          <dt>Pross. Pagamento</dt>
          <dd>
            {moment(rc_quotation.insurance_request.policy_effective_date)
              .add(Math.floor(365 / rc_quotation.payment_frequency), 'days')
              .toDate()
              .toLocaleDateString('it-IT')}
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Premio</dt>
          <dd>
            {(
              rc_quotation.amount
              - parseFloat(rc_quotation.issuance_fee)
              - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)
            ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            {' '}
            &euro;
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Spese di Emissione</dt>
          <dd>
            {(
              parseFloat(rc_quotation.issuance_fee)
              + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)
            ).toFixed(2)}
            {' '}
            &euro;
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Provvigioni</dt>
          <dd>
            {rc_quotation.commision.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            {' '}
            &euro;
          </dd>
        </CompletedField>
        <CompletedField>
          <dt>Brokeraggio</dt>
          <dd>
            {rc_quotation.brokerage_amount.toFixed(2)}
            {' '}
            &euro;
          </dd>
        </CompletedField>
      </CompletedFieldGrid>
    );
  };

  return (
    <>
      <div className="col-12 col-md-6 mb-3">
        <CompletedCard className="polizze-emessa-status-step-three">
          <CompletedCardHeader>
            <CompletedCardIcon>
              <FontAwesomeIcon icon={faShieldAlt} />
            </CompletedCardIcon>
            <CompletedCardTitle>Dati Responsabilita Civile</CompletedCardTitle>
          </CompletedCardHeader>
          {renderRCQuotationContent()}
        </CompletedCard>
      </div>

      {risk_quotations.map((risk_quote, index) => (
        <div className="col-12 col-md-6 mb-3" key={index}>
          <CompletedCard className="polizze-emessa-status-step-three">
            <CompletedCardHeader>
              <CompletedCardIcon>
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
              </CompletedCardIcon>
              <CompletedCardTitle>
                {getQuotationTypeName(risk_quote.quote_type, quoteTypes) === ''
                  ? getExtraCommercialQuoteTypeName(risk_quote.quote_type)
                  : getQuotationTypeName(risk_quote.quote_type, quoteTypes)}
              </CompletedCardTitle>
            </CompletedCardHeader>
            <CompletedFieldGrid>
              <CompletedField>
                <dt>Compagnia</dt>
                <dd>{risk_quote.company.name}</dd>
              </CompletedField>
              <CompletedField>
                <dt>Stato</dt>
                <dd>
                  {risk_quote.status === 7 && 'Polizza Emmesa'}
                </dd>
              </CompletedField>
              <CompletedField>
                <dt>Data Decorrenza</dt>
                <dd>
                  {moment(risk_quote.insurance_request.policy_effective_date)
                    .toDate()
                    .toLocaleDateString('it-IT')}
                </dd>
              </CompletedField>
              <CompletedField>
                <dt>Freq. Pagamento</dt>
                <dd>
                  {risk_quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
                </dd>
              </CompletedField>
              <CompletedField>
                <dt>Pagato</dt>
                <dd>
                  {risk_quote.amount_paid === null
                    ? '0.00'
                    : parseFloat(risk_quote.amount_paid).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
              {/* Da Pagare (temporarily hidden)
              <CompletedField>
                <dt>Da Pagare</dt>
                <dd>
                  {risk_quote.amount_paid === risk_quote.amount
                    ? '0.00'
                    : (
                      Math.ceil(risk_quote.amount * 100) / 100
                      - risk_quote.amount_paid
                    ).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
              */}
              <CompletedField>
                <dt>Pross. Pagamento</dt>
                <dd>
                  {moment(risk_quote.insurance_request.policy_effective_date)
                    .add(Math.floor(365 / risk_quote.payment_frequency), 'days')
                    .toDate()
                    .toLocaleDateString('it-IT')}
                </dd>
              </CompletedField>
              <CompletedField>
                <dt>Premio</dt>
                <dd>
                  {parseFloat(risk_quote.amount).toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
              {/* Totale (temporarily hidden)
<CompletedField className="full total">
                <dt>Totale</dt>
                <dd>
                  {risk_quote.amount.toFixed(2)}
                  {' '}
                  &euro;
                </dd>
              </CompletedField>
*/}
            </CompletedFieldGrid>
          </CompletedCard>
        </div>
      ))}
    </>
  );
}

export default CompletedQuoteScreenInfoCommercial;
